import type { parseFilterModel } from '@/lib/createAgGridDatasource';
import { buildDownloadOptions as buildDownloadOptionsShared, type SortColumnState } from '@/lib/downloadOptions';
import type { OrgFilters, OrgsDownloadOptions } from '@/services/organizations';
import type { OrgSortField } from '@/types';

export const VALID_SORT_FIELDS: readonly OrgSortField[] = [
  'name',
  'alias',
  'email_domain',
  'num_studies',
  'created_at',
  'updated_at',
];

// OrgFilters has no generated schema (orgs have no /search endpoint) — this list is the backend
// endpoint description's own documented set of accepted keys.
const VALID_FILTER_FIELDS: readonly (keyof OrgFilters)[] = [
  'name',
  'alias',
  'email_domain',
  'address',
  'num_studies',
  'created_at',
  'updated_at',
];

export function buildDownloadOptions(
  columnState: readonly SortColumnState[],
  filterModel: Parameters<typeof parseFilterModel>[0],
): OrgsDownloadOptions {
  return buildDownloadOptionsShared(columnState, filterModel, VALID_SORT_FIELDS, VALID_FILTER_FIELDS);
}
